@if (!job()) {
  <p-button
    test-id="download-options-export-as-python-code"
    [buttonProps]="{ autofocus: false }"
    [disabled]="downloadInProgress()"
    [loading]="downloadInProgress()"
    (click)="onExportCode($event)"
    [style]="{ 'justify-content': 'start' }"
    fluid
    variant="text"
    severity="contrast"
    [label]="downloadInProgress() ? 'Exporting Python Code...' : 'Export As Python Code'"
    icon="pi pi-file" />
} @else {
  <p-button
    test-id="download-options-export"
    [buttonProps]="{ autofocus: false }"
    (click)="onExportDocument()"
    [disabled]="downloadInProgress()"
    [loading]="downloadInProgress()"
    [style]="{ 'justify-content': 'start' }"
    fluid
    variant="text"
    severity="contrast"
    [label]="downloadInProgress() ? 'Exporting Document...' : 'Export'" />
}

@if (pythonCode.isShowCodeVisible()) {
  <cor-dialog-box
    [(visible)]="pythonCode.isShowCodeVisible"
    styleClass="export-dialog-box"
    [style]="{ width: '80vw' }">
    <ng-template #header>
      <div class="tw:flex tw:justify-between tw:w-full tw:me-2">
        <h3 class="tw:text-3xl">Export {{ OBJECT_DISPLAY_NAMES[object()] }}</h3>
      </div>
    </ng-template>
    <div class="tw:flex tw:flex-col tw:gap-4">
      @if (examplePythonCode()) {
        <div>
          <!-- Example code -->
          <div class="tw:flex tw:flex-col tw:mb-2">
            <div class="tw:text-xl tw:font-semibold tw:text-color">Run a basic code sample</div>
            <small class="tw:text-muted-color">
              This sample demonstrates a basic call to
              <code>{{ item().alias }}</code>
            </small>
          </div>
          <cor-code-mirror
            [ngModel]="examplePythonCode()"
            [disabled]="true"
            [showRequirements]="false"
            [allowFullHeight]="true" />
        </div>
      }
      <div>
        <div class="tw:flex tw:flex-col tw:mb-2">
          <div class="tw:font-semibold tw:text-color tw:flex tw:justify-between">
            <span class="tw:text-xl">Exported Python Code</span>
            <div class="tw:flex tw:items-center tw:justify-between tw:gap-3 tw:ms-auto">
              <div
                class="tw:flex tw:gap-1 tw:items-center"
                pTooltip="Whether to comment the corridor decorators in the python code">
                <label>
                  <p-checkbox
                    test-id="download-options-p-checkbox"
                    [(ngModel)]="pythonCode.commentDecorators"
                    [binary]="true" />
                  Hide Decorators
                </label>
              </div>
              <p-button
                test-id="download-options-download-zip"
                [buttonProps]="{ autofocus: false }"
                (click)="downloadCodeAsZip()"
                [label]="pythonCode.isExporting() ? 'Downloading...' : 'Download ZIP'"
                [loading]="pythonCode.isExporting()"
                size="small"
                icon="pi pi-download" />
            </div>
          </div>
        </div>
        <cor-code-mirror
          [ngModel]="visibleCode()"
          [disabled]="true"
          [showRequirements]="false"
          [allowFullHeight]="true" />
      </div>
    </div>
  </cor-dialog-box>
}
